// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 250px;
}

.content-expanded {
  transition: margin-left 0.3s ease;
}

.bg-zikata {
  background-color: #2e005d;
}`, "",{"version":3,"sources":["webpack://./apps/clients-portal/src/app/layouts/default-layout/default-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".sidebar {\n  width: 250px;\n}\n\n.content-expanded {\n  transition: margin-left 0.3s ease;\n}\n\n.bg-zikata {\n  background-color: #2e005d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
